// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__392v8","content":"Consent_content__3CeSc","footer":"Consent_footer__2grGp"};